<template>
  <v-container class="video-container">
    <v-row justify="center" align="center">
      <v-col cols="12" md="10" lg="8">
        <v-card class="video-card">
          <div class="video-wrapper">
            <iframe
              :src="videoSrc"
              class="video-frame"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <v-card-text v-if="title" class="text-center">
            <h3 class="text-h6">{{ title }}</h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'VideoComponent',
  props: {
    videoSrc: {
      type: String,
      required: true,
      validator: function(value) {
        return value.includes('youtube.com/embed/') || value.includes('youtu.be/')
      }
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.video-container {
  padding: 24px 0;
}

.video-card {
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
}

.video-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

@media (max-width: 600px) {
  .video-container {
    padding: 16px 0;
  }
}
</style>
